export const blockIconsAndroidSimCardDownloadNew = (
	<span className='material-symbols-outlined'>sim_card_download</span>
);
